// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"044957db","650":"88aeee02","730":"044957db","750":"d4315e0f"}[chunkId] + ".chunk.css";
};